import { c as _c } from "react/compiler-runtime";
import { CallOutlined } from "@mui/icons-material";
import { useTranslations } from "next-intl";
import React, { useMemo } from "react";
import { type DialogButton } from "@/app/components/ErrorDialog/ErrorDialog";
import { PATIENT_SERVICES_BASE_PATH } from "@/lib/constants";
import { useSchedulerActor, useSchedulerSelector } from "@/lib/hooks/useSchedulerMachine";
import { formatPhoneNumber } from "@/lib/utils/format-phone-number";
import { dataLayerPushExistingAccount } from "@/lib/utils/modalDataLayerPush";
import styles from "@/app/components/ErrorDialog/ErrorDialog.module.css";
interface ErrorDialogConfig {
  title?: React.ReactNode;
  body: string;
  buttons: DialogButton[];
  iconColor: string;
}
const ELIGIBILITY_CODES = new Set<string>(["existingPatient_with_appt", "existingPatient_no_appt", "newPatient_with_appt"]);
export default function useErrorDialogConfig(errorCode, phoneNumber, onClose) {
  const $ = _c(94);
  const actorRef = useSchedulerActor();
  const webFacilityDetails = useSchedulerSelector(_temp);
  const validatedPatient = useSchedulerSelector(_temp2);
  const t = useTranslations("ErrorDialog");
  let t0;
  bb0: {
    if (errorCode && ELIGIBILITY_CODES.has(errorCode)) {
      const t1 = `${errorCode}.body`;
      let t2;
      if ($[0] !== t || $[1] !== t1) {
        t2 = t(t1);
        $[0] = t;
        $[1] = t1;
        $[2] = t2;
      } else {
        t2 = $[2];
      }
      const body = t2;
      let t3;
      if ($[3] !== errorCode || $[4] !== t) {
        t3 = errorCode === "newPatient_with_appt" ? [{
          label: t("patientPortalLogin"),
          variant: "primary",
          className: styles.darkButton,
          onClick: _temp3
        }] : [];
        $[3] = errorCode;
        $[4] = t;
        $[5] = t3;
      } else {
        t3 = $[5];
      }
      const portalButtons = t3;
      const t4 = `${errorCode}.title`;
      let t5;
      if ($[6] !== t || $[7] !== t4) {
        t5 = t(t4);
        $[6] = t;
        $[7] = t4;
        $[8] = t5;
      } else {
        t5 = $[8];
      }
      let t6;
      if ($[9] !== phoneNumber) {
        t6 = formatPhoneNumber(phoneNumber);
        $[9] = phoneNumber;
        $[10] = t6;
      } else {
        t6 = $[10];
      }
      let t7;
      if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = <CallOutlined />;
        $[11] = t7;
      } else {
        t7 = $[11];
      }
      let t8;
      if ($[12] !== body || $[13] !== errorCode || $[14] !== phoneNumber || $[15] !== validatedPatient || $[16] !== webFacilityDetails) {
        t8 = () => {
          globalThis.location.href = `tel:${phoneNumber}`;
          dataLayerPushExistingAccount("click to call", webFacilityDetails, validatedPatient, errorCode, body);
        };
        $[12] = body;
        $[13] = errorCode;
        $[14] = phoneNumber;
        $[15] = validatedPatient;
        $[16] = webFacilityDetails;
        $[17] = t8;
      } else {
        t8 = $[17];
      }
      let t9;
      if ($[18] !== t6 || $[19] !== t8) {
        t9 = {
          label: t6,
          variant: "secondary",
          icon: t7,
          className: "InvocaNumber",
          onClick: t8
        };
        $[18] = t6;
        $[19] = t8;
        $[20] = t9;
      } else {
        t9 = $[20];
      }
      let t10;
      if ($[21] !== portalButtons || $[22] !== t9) {
        t10 = [...portalButtons, t9];
        $[21] = portalButtons;
        $[22] = t9;
        $[23] = t10;
      } else {
        t10 = $[23];
      }
      let t11;
      if ($[24] !== body || $[25] !== t10 || $[26] !== t5) {
        t11 = {
          title: t5,
          body,
          iconColor: "#f79009",
          buttons: t10
        };
        $[24] = body;
        $[25] = t10;
        $[26] = t5;
        $[27] = t11;
      } else {
        t11 = $[27];
      }
      t0 = t11;
      break bb0;
    } else {
      if (errorCode === "Schedule_PatientHasFutureAppointments" || errorCode === "Schedule_NotNewPatient") {
        let t1;
        if ($[28] !== t) {
          t1 = t("alreadyHasApptTitle");
          $[28] = t;
          $[29] = t1;
        } else {
          t1 = $[29];
        }
        let t2;
        if ($[30] !== phoneNumber || $[31] !== t) {
          t2 = t("alreadyHasApptBody", {
            phoneNumber: formatPhoneNumber(phoneNumber)
          });
          $[30] = phoneNumber;
          $[31] = t;
          $[32] = t2;
        } else {
          t2 = $[32];
        }
        let t3;
        if ($[33] !== phoneNumber) {
          t3 = formatPhoneNumber(phoneNumber);
          $[33] = phoneNumber;
          $[34] = t3;
        } else {
          t3 = $[34];
        }
        let t4;
        if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
          t4 = <CallOutlined />;
          $[35] = t4;
        } else {
          t4 = $[35];
        }
        const t5 = `tel:${phoneNumber}`;
        let t6;
        if ($[36] !== validatedPatient || $[37] !== webFacilityDetails) {
          t6 = () => {
            dataLayerPushExistingAccount("click to call", webFacilityDetails, validatedPatient);
          };
          $[36] = validatedPatient;
          $[37] = webFacilityDetails;
          $[38] = t6;
        } else {
          t6 = $[38];
        }
        let t7;
        if ($[39] !== t3 || $[40] !== t5 || $[41] !== t6) {
          t7 = [{
            label: t3,
            variant: "secondary",
            icon: t4,
            className: "InvocaNumber",
            href: t5,
            onClick: t6
          }];
          $[39] = t3;
          $[40] = t5;
          $[41] = t6;
          $[42] = t7;
        } else {
          t7 = $[42];
        }
        let t8;
        if ($[43] !== t1 || $[44] !== t2 || $[45] !== t7) {
          t8 = {
            title: t1,
            body: t2,
            iconColor: "#f79009",
            buttons: t7
          };
          $[43] = t1;
          $[44] = t2;
          $[45] = t7;
          $[46] = t8;
        } else {
          t8 = $[46];
        }
        t0 = t8;
        break bb0;
      } else {
        if (errorCode === "Schedule_TimeSlotNotAvailable") {
          let t1;
          if ($[47] !== t) {
            t1 = t("timeSlotNotAvailableBody");
            $[47] = t;
            $[48] = t1;
          } else {
            t1 = $[48];
          }
          let t2;
          if ($[49] !== t) {
            t2 = t("selectAnotherTime");
            $[49] = t;
            $[50] = t2;
          } else {
            t2 = $[50];
          }
          let t3;
          if ($[51] !== actorRef || $[52] !== onClose) {
            t3 = () => {
              actorRef.send({
                type: "GOTO_STEP",
                step: "dateTimeSelection"
              });
              onClose?.();
            };
            $[51] = actorRef;
            $[52] = onClose;
            $[53] = t3;
          } else {
            t3 = $[53];
          }
          let t4;
          if ($[54] !== t2 || $[55] !== t3) {
            t4 = [{
              label: t2,
              variant: "primary",
              onClick: t3
            }];
            $[54] = t2;
            $[55] = t3;
            $[56] = t4;
          } else {
            t4 = $[56];
          }
          let t5;
          if ($[57] !== t1 || $[58] !== t4) {
            t5 = {
              body: t1,
              iconColor: "#F04438",
              buttons: t4
            };
            $[57] = t1;
            $[58] = t4;
            $[59] = t5;
          } else {
            t5 = $[59];
          }
          t0 = t5;
          break bb0;
        } else {
          if (errorCode === "ageIneligible") {
            let t1;
            if ($[60] !== phoneNumber) {
              t1 = formatPhoneNumber(phoneNumber);
              $[60] = phoneNumber;
              $[61] = t1;
            } else {
              t1 = $[61];
            }
            const formattedPhone = t1;
            let t2;
            if ($[62] !== t) {
              t2 = t("ageIneligibleTitlePre");
              $[62] = t;
              $[63] = t2;
            } else {
              t2 = $[63];
            }
            const t3 = `tel:${phoneNumber}`;
            let t4;
            if ($[64] !== formattedPhone || $[65] !== t3) {
              t4 = <a href={t3} className={`InvocaNumber ${styles.titlePhone}`}>{formattedPhone}</a>;
              $[64] = formattedPhone;
              $[65] = t3;
              $[66] = t4;
            } else {
              t4 = $[66];
            }
            let t5;
            if ($[67] !== t) {
              t5 = t("ageIneligibleTitlePost");
              $[67] = t;
              $[68] = t5;
            } else {
              t5 = $[68];
            }
            let t6;
            if ($[69] !== t2 || $[70] !== t4 || $[71] !== t5) {
              t6 = <>{t2}{" "}{t4}{" "}{t5}</>;
              $[69] = t2;
              $[70] = t4;
              $[71] = t5;
              $[72] = t6;
            } else {
              t6 = $[72];
            }
            let t7;
            if ($[73] !== t) {
              t7 = t("ageIneligibleBody");
              $[73] = t;
              $[74] = t7;
            } else {
              t7 = $[74];
            }
            let t8;
            if ($[75] === Symbol.for("react.memo_cache_sentinel")) {
              t8 = <CallOutlined />;
              $[75] = t8;
            } else {
              t8 = $[75];
            }
            const t9 = `tel:${phoneNumber}`;
            let t10;
            if ($[76] !== formattedPhone || $[77] !== t9) {
              t10 = [{
                label: formattedPhone,
                variant: "secondary",
                icon: t8,
                className: "InvocaNumber",
                href: t9
              }];
              $[76] = formattedPhone;
              $[77] = t9;
              $[78] = t10;
            } else {
              t10 = $[78];
            }
            let t11;
            if ($[79] !== t10 || $[80] !== t6 || $[81] !== t7) {
              t11 = {
                title: t6,
                body: t7,
                iconColor: "#F04438",
                buttons: t10
              };
              $[79] = t10;
              $[80] = t6;
              $[81] = t7;
              $[82] = t11;
            } else {
              t11 = $[82];
            }
            t0 = t11;
            break bb0;
          } else {
            if (errorCode) {
              let formattedPhone_0;
              let t1;
              if ($[83] !== phoneNumber || $[84] !== t) {
                formattedPhone_0 = formatPhoneNumber(phoneNumber);
                t1 = t("alreadyHasApptBody", {
                  phoneNumber: formattedPhone_0
                });
                $[83] = phoneNumber;
                $[84] = t;
                $[85] = formattedPhone_0;
                $[86] = t1;
              } else {
                formattedPhone_0 = $[85];
                t1 = $[86];
              }
              let t2;
              if ($[87] === Symbol.for("react.memo_cache_sentinel")) {
                t2 = <CallOutlined />;
                $[87] = t2;
              } else {
                t2 = $[87];
              }
              const t3 = `tel:${phoneNumber}`;
              let t4;
              if ($[88] !== formattedPhone_0 || $[89] !== t3) {
                t4 = [{
                  label: formattedPhone_0,
                  variant: "secondary",
                  icon: t2,
                  className: "InvocaNumber",
                  href: t3
                }];
                $[88] = formattedPhone_0;
                $[89] = t3;
                $[90] = t4;
              } else {
                t4 = $[90];
              }
              let t5;
              if ($[91] !== t1 || $[92] !== t4) {
                t5 = {
                  body: t1,
                  iconColor: "#F04438",
                  buttons: t4
                };
                $[91] = t1;
                $[92] = t4;
                $[93] = t5;
              } else {
                t5 = $[93];
              }
              t0 = t5;
              break bb0;
            }
          }
        }
      }
    }
    t0 = null;
  }
  return t0;
}
function _temp3() {
  globalThis.location.href = PATIENT_SERVICES_BASE_PATH;
}
function _temp2(s_0) {
  return s_0.context.validatedPatientResponse;
}
function _temp(s) {
  return s.context.facility;
}